export default {
  requestLocationBottomSheet: {
    title: 'We need your location to find no-fee ATMs nearby.',
    body: 'Turn on location services in your device settings. You can also search for ATMs by entering an address or ZIP code.',
    button: {
      enableLocation: 'Enable location',
      noThankYou: 'No thank you',
    },
  },
  predictionMap: {
    searchPlaceholder: 'Enter Address or ZIP code',
    searchThisAreaButton: 'Search this area',
  },
};
